export const TABLES = {
    USER: "user",
    USER_IMAGE: "user_image",
    DEVICES: 'device',
    EMPLOYEES: 'employee',
    CONTRACTORS: 'contractor',
    CONTRACTS: 'contract',
    ORDERS: 'purchase',
    SUPPLIERS: 'supplier',
    VEHICLES: 'vehicle_company',
    ATTENDANCE: 'attendance',
    ATTENDANCE_MAP: 'attendance_map',
    USER_ACCESS_LOG: 'user_access_log',
    VEHICLE_ACCESS_LOG: 'vehicle_access_log',
    RESOURCES: 'resource',
    CONTRACTOR_EMPLOYEE: 'contractor_employee',
    SUPPLIER_EMPLOYEE: 'supplier_employee',
    CONTRACTOR_VEHICLE: 'contractor_vehicle',
    SUPPLIER_VEHICLE: 'supplier_vehicle',
    LOG_IN_LOG: 'log_in_log',
    LOG_MODULE: 'log_module',
    EVENT: 'event',
    EVENT_STATUS: 'event_status',
    CARD: 'card',
    TEMPLATE: 'template',
    ZONE: 'zone',
    DEPARTMENT: 'department',
    ROLE: 'role',
    WORKSHIFT: 'work_shift',
    VISITOR_TYPES: 'visitor_types',
    USER_INVITATION: 'user_invitation',
    VISITOR_REQUEST: 'visitor_request',
    VISITOR_FIELD_SUBMISSIONS: 'visitor_field_submissions',
    VISITOR_FIELD: 'visitor_field',
    FOODIE:'foodie',
    FOODIE_CAFETERIA: "foodie_cafeteria",
    FOODIE_CAFETERIA_ORDERS: "foodie_cafeteria_orders",
    DISTRIBUTION_CENTER: 'distribution_center',
    SERVICETYPE: 'service_type',
    LOGISTICREQUEST: 'logistic_request',
    PURCHASE: 'purchase',
    APPROVALTRACKER : 'approval_tracker',
    FOODIE_USER_MENU:'foodie_user_menu',
    // Add more tables here

    // Documents
    EMPLOYEE_DOCUMENT_COMPANY: 'employee_document_company',
    EMPLOYEE_DOCUMENT_COMPANY_FILE: 'employee_document_company_file',
    SUPPLIER_DOCUMENT_COMPANY: 'supplier_document_company',
    SUPPLIER_DOCUMENT_COMPANY_FILE: 'supplier_document_company_file',
    CONTRACTOR_DOCUMENT_COMPANY: 'contractor_document_company',
    CONTRACTOR_DOCUMENT_COMPANY_FILE: 'contractor_document_company_file',
    // Documents Vehicle
    SUPPLIER_VEHICLE_DOCUMENT_COMPANY: "supplier_vehicle_document_company",
    SUPPLIER_VEHICLE_DOCUMENT: "supplier_vehicle_document",
    SUPPLIER_VEHICLE_DOCUMENT_COMPANY_FILE: "supplier_vehicle_document_company_file",
    CONTRACTOR_VEHICLE_DOCUMENT: "contractor_vehicle_document",
    CONTRACTOR_VEHICLE_DOCUMENT_COMPANY: "contractor_vehicle_document_company",
    CONTRACTOR_VEHICLE_DOCUMENT_COMPANY_FILE: "contractor_vehicle_document_company_file",
    APPROVAL :"approval_flow",
    INGREDIENT: "ingredient",
    INGREDIENT_IMAGE: "ingredient_image",
    MENU:"foodie_menu",
    FOODIE_TYPE: "foodie_type", // foodie_meals
    FOODIE_SHIFT: "foodie_shift",
    DISH: "foodie_item",
    DISH_IMAGE: "foodie_item_image",
    FOODIE_DEPARTMENT: "foodie_department",
    FOODIE_USER_MENU_SELECTION: "foodie_user_menu_selection",
    VISITOR: "visitor",
    FOODIE_REQUEST:"foodie_request",
    REQUEST_ACCESS_VISITOR:"request_access_visitor",
    FOODIE_HISTORY:"foodie_history",
    REQUEST_ACCESS_EMPLOYEE:"request_access_employee",
    REQUEST_ACCESS: "request_access",
    FOODIE_MENU_TOTAL_MEALS: "foodie_menu_total_meals",
    USER_FILE: "user_file",
    FOODIE_ACCESS: "foodie_access",
    FOODIE_MEAL_FORECAST: "forecast",
    TRAFFIC:"traffic", //change to traffic
    FINE:"fine",
    FINE_USER:"fine_user",
    FINE_TYPE: "fine_type",
    USER_VEHICLE_COMPANY: "user_vehicle_company",
    USER_WORK_SCHEDULE:"user_work_schedule",
    WORK_SHIFT_SCHEDULE: "work_shift_schedule",
    CONTRACTOR_WORK_SCHEDULE:"contractor_work_schedule",
    USER_BY_USER_TYPE: "user_by_user_type",
    USER_BY_CONTRACTOR_ID: "user_by_contractor_id",
    USER_BY_SUPPLIER_ID: "user_by_supplier_id",
    GEOFENCE: "geofence",
    COMMON_AREA: "common_area",
    HID: "hid",
    HID_CARD_FORMAT: "hid_card_format",
    HID_INPUT:"hid_input",
    HID_OUTPUT:"hid_output",
    HID_READER: "hid_reader",
    HID_SIO: "hid_sio",
    HID_ACR: "hid_acr",
    USER_NOT_ASSIGNED_TO_DEPARTMENT: "user_not_assigned_to_department",
    USER_NOT_ASSIGNED_TO_ROLE: "user_not_assigned_to_role",
    USER_NOT_ASSIGNED_TO_WORK_SCHEDULE: "user_not_assigned_to_work_schedule",
    USER_NOT_ASSIGNED_TO_ZONE: "user_not_assigned_to_zone",
    USER_NOT_ASSIGNED_TO_CONTRACT: "user_not_assigned_to_contract",
    VEHICLE_NOT_ASSIGNED_TO_CONTRACT: "vehicle_not_assigned_to_contract",
    VEHICLE_BY_SUPPLIER_ID: "vehicle_by_supplier_id",
    CONTRACTOR_EMPLOYEE_DOCUMENTATION_LEVEL: "contractor_employee_documentation_level",
    CONTRACTOR_VEHICLE_DOCUMENTATION_LEVEL: "contractor_vehicle_documentation_level",
    SUPPLIER_EMPLOYEE_DOCUMENTATION_LEVEL: "supplier_employee_documentation_level",
    SUPPLIER_VEHICLE_DOCUMENTATION_LEVEL: "supplier_vehicle_documentation_level",
    HISTORY_CONTRACTOR_IN_CHARGE_DOCUMENTATION_LEVEL: "history_contractor_in_charge_documentation_level",
    HISTORY_SUPPLIER_IN_CHARGE_DOCUMENTATION_LEVEL: "history_supplier_in_charge_documentation_level",
    HISTORY_CONTRACTOR_EMPLOYEE_DOCUMENTATION_LEVEL: "history_contractor_employee_documentation_level",
    HISTORY_SUPPLIER_EMPLOYEE_DOCUMENTATION_LEVEL: "history_supplier_employee_documentation_level",
    HISTORY_CONTRACTOR_VEHICLE_DOCUMENTATION_LEVEL: "history_contractor_vehicle_documentation_level",
    HISTORY_SUPPLIER_VEHICLE_DOCUMENTATION_LEVEL: "history_supplier_vehicle_documentation_level",
    REQUEST_CONTRACTOR: "request_contractor",
    REQUEST_SUPPLIER: "request_supplier",
    EQUIPMENT_MATERIAL:'equipment',
    ATTENDANCE_SHIFT:"attendance_shift",
    ATTENDANCE_MANAGE:"attendance_manage",
    EQUIPMENT_ACCESS_LOG:'equipment_access_log',
    CATEGORY: "equipment_category",
    FOODIE_USER_MENU_SELECTION_HISTORY:"foodie_user_menu_selection_history",
    ATTENDANCE_DEPARTMENT:"attendance_department",
    DEPARTMENT_TOTAL_EMPLOYEES: "department_total_employees",
    KITCHEN_ACCESS: "kitchen_access",
    KITCHEN_ACCESS_HISTORY: "kitchen_access_history",
    EXTRA_REQUEST_HISTORY: "extra_request_history",
    ADMIN_EXTRA_REQUEST_ACTIVE: "admin_extra_request_active",
    ADMIN_EXTRA_REQUEST_HISTORY: "admin_extra_request_history",
    EXTRA_DATA: "extra_data",
    USER_SPECIAL_PERMISSION: "user_special_permission",
    EVENT_ATTENDANCE_LIST:"event_attendance_list",
    EVENT_ATTENDANCE_LIST_PENDING_VALIDATED :"event_attendance_list_pending_validated",
    EVENT_ATTENDANCE_LIST_PENDING_CHECK_IN :"event_attendance_list_pending_check_in",
    EVENT_ATTENDANCE_LIST_TOTAL_CHECK_IN: "event_attendance_list_total_check_in",
    EVENT_ATTENDANCE_LIST_WHITE_LIST:"event_attendance_list_white_list",
    CARD_AVAILABLE: "card_available",
    DEPARTMENT_SHIFT: "department_shift",
    DEVICE_CUSTOM_ACCESS : "device_custom_access",
    DEVICE_DEPARTMENT : "device_department",
    SHIFT_DEVICE : "shift_device",
    SHIFT_DEPARTMENT : "shift_department",
    SHIFT_CUSTOM_ACCESS : "shift_custom_access",
    FOODIE_SHIFT_CAFETERIA : "foodie_shift_cafeteria",
    FOODIE_SHIFT_DEPARTMENT : "foodie_shift_department",
    FOODIE_SHIFT_CUSTOM_ACCESS : "foodie_shift_custom_access",
    WORK_SHIFT_DEPARTMENT : "work_shift_department",
    WORK_SHIFT_CUSTOM_ACCESS : "work_shift_custom_access",
    DEPARTMENT_SUPERVISOR: 'department_supervisor'
};
